import {
  EventReportsFilterDTO,
  TrackReportViewedDTO,
  TrackSocialListeningDTO,
  TrackSupplierPageSelectedDto,
} from './event-endpoints.types';
import { principalServiceRequest } from './base-request';

export const trackUserLoggedIn = async (currentPrincipal: string) => {
  try {
    return principalServiceRequest('post', 'events/login', {
      principalSlug: currentPrincipal,
    });
  } catch (error) {
    console.log(error);
  }
};

export const trackGlobalFilterChange = (body: EventReportsFilterDTO) => {
  return principalServiceRequest<void>('post', 'events/global-filter', body);
};

export const trackSupplierPageChange = (body: TrackSupplierPageSelectedDto) => {
  return principalServiceRequest<void>(
    'post',
    'events/supplier-page/select',
    body,
  );
};

export const trackInsightsLinkClick = async (
  principalId: string,
  marketInsightTitle: string,
) => {
  return principalServiceRequest('post', 'events/market-insights/click', {
    principalId,
    marketInsightTitle,
  });
};

export const trackInsightsShare = async (
  principalId: string,
  marketInsightTitle: string,
) => {
  return principalServiceRequest('post', 'events/market-insights/share', {
    principalId,
    marketInsightTitle,
  });
};

export const trackSocialListeningDownload = async (
  data: TrackSocialListeningDTO,
) => {
  return principalServiceRequest('post', 'events/insights/download', data);
};

export const trackPageViewed = (body: TrackReportViewedDTO) => {
  return principalServiceRequest('post', 'events/page/view', body);
};

export const trackSharepointDownload = async (
  data: TrackSocialListeningDTO,
) => {
  return principalServiceRequest(
    'post',
    'events/shared-documents/download',
    data,
  );
};
